import { api } from "./api_client";
import { Game } from "../models/game";
import { transformGameData } from "../utils/game_transforms";
import axios from "axios";

export default async function createGame(
  difficulty: "easy" | "medium" | "hard",
  region: "usa" | "eur" | "world",
  signal?: AbortSignal
): Promise<Game> {
  try {
    const body = {
      game: {
        game_type: "competition",
        difficulty: difficulty,
        region: region,
        rounds: difficulty === "easy" ? 3 : 5,
      },
    };

    const response = await api.post("/games/new", body, { signal });
    return transformGameData(response.data);
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request aborted");
    } else {
      console.error("Error fetching data:", error);
    }

    throw error;
  }
}

export const completeGame = async (
  gameId: string,
  score: number,
  signal?: AbortSignal
) => {
  const response = await api.post(
    `/games/${gameId}/complete`,
    { score },
    { signal }
  );
  return transformGameData(response.data);
};
